export const SOFT_RELOAD_CARD = "metabase/qb/SOFT_RELOAD_CARD";
export const API_UPDATE_QUESTION = "metabase/qb/API_UPDATE_QUESTION";
